import React, {
  ReactElement, ReactNode, useEffect, useMemo, useState,
} from 'react';
import { useSearchParams, useLocation } from 'react-router-dom';
import Context, { HistoryContextType } from './HistoryContext';

interface Props {
  children: ReactNode;
}

const HistoryContextProvider = ({ children }: Props): ReactElement => {
  const [lastVisitedListPage, setLastVisitedListPage] = useState<string>(null);
  const currentLocation = useLocation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (currentLocation.pathname.includes('zobraz')) {
      setLastVisitedListPage(`${currentLocation.pathname}?${searchParams.toString()}`);
    }
  }, [currentLocation, searchParams]);

  const value: HistoryContextType = useMemo(() => ({
    lastVisitedListPage,
  }), [lastVisitedListPage]);

  return (
    <Context.Provider value={value}>
      {children}
    </Context.Provider>
  );
};

export default HistoryContextProvider;
